import { Button, Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import CourseAddition from '../../Steps/components/CourseAddition/_CourseAddition';

function CourseModal({ show, selectedCourses, handleClose, action, mainAction }) {
  const handleCourseClick = (course) => {
    let tempLinkedCourses = [...(selectedCourses || [])];
    let linkedCourseIndex = tempLinkedCourses.findIndex(
      (linkedCourse) => linkedCourse.id === course.id
    );
    if (linkedCourseIndex === -1) {
      let tempCourse = {
        title: course.title,
        id: course.id,
        slug: course.slug,
        created_by: course.created_by,
        thumbnail_image: course.thumbnail_image
      };
      tempLinkedCourses.push(tempCourse);
    } else {
      tempLinkedCourses.splice(linkedCourseIndex, 1);
    }
    action(tempLinkedCourses);
  };
  return (
    <Modal show={show} onHide={handleClose} size="lg" className="custom-modal">
      <Modal.Header closeButton centered>
        <Modal.Title>
          <FormattedMessage id="courses" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CourseAddition handleCourseClick={handleCourseClick} selectedCourses={selectedCourses} />
      </Modal.Body>
      <Modal.Footer>
        <div className="w-100 d-flex align-items-center justify-content-center">
          <Button onClick={mainAction || handleClose}>
            <FormattedMessage id="button.add" />
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default CourseModal;
